import * as React from "react";
import { Card as ChakraCard, type CardRootProps, type CardBodyProps } from "@chakra-ui/react";

export type CardProps = CardRootProps & {
  children?: React.ReactNode;
  bodyProps?: CardBodyProps;
};

export const Card: React.FC<CardProps> = ({ bodyProps, children, ...rest }) => {
  return (
    <ChakraCard.Root {...rest}>
      <ChakraCard.Body {...bodyProps}>{children}</ChakraCard.Body>
    </ChakraCard.Root>
  );
};
